import { CourseLectureAssignmentStatusEnum } from 'modules/course/types/course-menu-interface'

export const getAssignmentStatusTextColor = (
  status?: CourseLectureAssignmentStatusEnum,
): 'text-danger' | 'text-green' | 'text-text-primary' | 'text-text-tertiary' | undefined => {
  switch (status) {
    case CourseLectureAssignmentStatusEnum.Approved: {
      return 'text-green'
    }
    case CourseLectureAssignmentStatusEnum.Rejected: {
      return 'text-danger'
    }
    case CourseLectureAssignmentStatusEnum.Pending: {
      return 'text-text-primary'
    }
    case CourseLectureAssignmentStatusEnum.NotSubmitted: {
      return 'text-text-tertiary'
    }
    default: {
      break
    }
  }

  return undefined
}

export const getAssignmentStatusBackgroundColor = (
  status?: CourseLectureAssignmentStatusEnum,
): 'bg-brand-primary/15' | 'bg-background-primary' | 'bg-danger/20' | 'bg-green/20' | undefined => {
  switch (status) {
    case CourseLectureAssignmentStatusEnum.Approved: {
      return 'bg-green/20'
    }
    case CourseLectureAssignmentStatusEnum.Rejected: {
      return 'bg-danger/20'
    }
    case CourseLectureAssignmentStatusEnum.Pending: {
      return 'bg-brand-primary/15'
    }
    case CourseLectureAssignmentStatusEnum.NotSubmitted: {
      return 'bg-background-primary'
    }
    default: {
      break
    }
  }

  return undefined
}
